module.exports = __webpack_public_path__ + "img/main_logo.25db04df.png";